import { isUndefined } from "@silo/utils";
import { useEffect, useMemo } from "react";
import { supportedWallets } from "./wallets";
import { useLocalStorage } from "@silo/ui";

const findSupportedWalletKey = (type: string) =>
  supportedWallets.find((supportedWallet) => supportedWallet.type === type)
    ?.type;

const usePersistedSelectedWalletValue = () => {
  const [maybePersistedWallet, setPersistedWallet, remove] = useLocalStorage<
    string | undefined
  >("selectedWallet", undefined);

  const maybeParsed = useMemo(
    () =>
      maybePersistedWallet
        ? findSupportedWalletKey(maybePersistedWallet)
        : undefined,
    [maybePersistedWallet]
  );

  useEffect(() => {
    if (!isUndefined(maybePersistedWallet)) {
      if (!findSupportedWalletKey(maybePersistedWallet)) {
        // clear the local storage value, as its stale and not valid any more
        remove();
      }
    }
  }, [maybePersistedWallet, remove]);

  return [maybeParsed, setPersistedWallet, remove] as const;
};

export const usePersistedSelectedWallet = () => {
  const [
    persistedSelectedWalletValue,
    setPersistedSelectedWalletValue,
    remove,
  ] = usePersistedSelectedWalletValue();

  const walletInfo = useMemo(
    () =>
      supportedWallets.find(
        (wallet) => wallet.type === persistedSelectedWalletValue
      ),
    [persistedSelectedWalletValue]
  );

  return [walletInfo, setPersistedSelectedWalletValue, remove] as const;
};
